import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'
import type { CreateStaticSiteFormValues } from '@/routes/static-sites/create-static-site/form/schema'

export const PullRequestPreviews = () => {
  const form = useFormContext<CreateStaticSiteFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('isPreviewEnabled')
    }
  }, [resetField])

  return (
    <FormField
      control={form.control}
      name="isPreviewEnabled"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between border rounded-lg shadow-xs p-4 gap-16">
            <div className="space-y-1">
              <FormLabel>Pull request previews</FormLabel>
              <FormDescription>
                Previews allow you to get a sneak peek at your pull requests
                before they're merged, allowing you to review and test changes
                more efficiently
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={Boolean(field.value)}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </div>
        </FormItem>
      )}
    />
  )
}
